'use client'
import { DictionaryTabsSelect, DictionaryTabsSelectProps } from '@/entities/dictionary'
import { Dto } from '../model/types/hypotheses-filter'
import { filterHypothesesSelectors, useFilterHypothesesStore } from '../model'
import { cn } from '@/shared/lib/classnames'

const defaultValue = 'default'

export interface ComponentProps extends DictionaryTabsSelectProps {
  updateField: keyof Dto
}

export default function Component({ updateField, ...props }: ComponentProps) {
  const storeValues = useFilterHypothesesStore(filterHypothesesSelectors.selectValues) || {}
  const setStore = useFilterHypothesesStore(filterHypothesesSelectors.selectSetValues)
  const setStoreValue = (v: string) => {
    setStore({
      values: {
        ...storeValues,
        [updateField]: v === defaultValue ? undefined : [v],
      },
    })
  }

  const storeValue = storeValues[updateField]
  const storeValueItem = storeValue ? storeValue[storeValue.length - 1] : defaultValue
  const tabValue = typeof storeValueItem !== 'object' ? storeValueItem : defaultValue

  return (
    <DictionaryTabsSelect
      variant="default"
      {...props}
      className={cn('w-78 mobile:w-96 md:w-fit lg:w-fit overflow-x-auto rounded-md', props?.className || '')}
      onValueChange={setStoreValue}
      defaultTabsTrigger={{ value: defaultValue }}
      value={tabValue || defaultValue}
    />
  )
}
